module.exports = __webpack_public_path__ + "static/media/new_banner.9a43f741.png";